var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation",
    class: _vm.navigationClasses
  }, [_c('div', {
    staticClass: "navigation__brand"
  }, [_c('router-link', {
    staticClass: "navigation__brand-link",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('logo', {
    staticClass: "navigation__brand-icon"
  }), _vm._v("Goliath"), _c('small', {
    staticClass: "navigation__brand-link-version"
  }, [_vm._v(" " + _vm._s(_vm.version) + " ")]), _vm._v(" "), _c('small', {
    staticClass: "navigation__brand-link-environment"
  }, [_vm._v(_vm._s(_vm.environmentName))])], 1)], 1), _vm._v(" "), _c('ul', {
    staticClass: "uk-nav-default uk-nav-parent-icon",
    attrs: {
      "uk-nav": ""
    }
  }, [_c('li', {
    staticClass: "uk-nav-divider uk-margin-top uk-margin-bottom"
  }), _vm._v(" "), _c('li', {
    staticClass: "uk-nav-header navigation__header"
  }, [_vm._v(_vm._s(_vm.$t('headers.catalog')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'brands'
      },
      "icon": "thumbnails"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.brands')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'product-families'
      },
      "icon": "album"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.productFamilies')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'products'
      },
      "icon": "file"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.products')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'product-styles'
      },
      "icon": "bookmark"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.productStyles')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'product-designs'
      },
      "icon": "heart"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.productDesigns')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'product-categories'
      },
      "icon": "tag"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.categories')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'contracts'
      },
      "icon": "file-edit"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.contracts')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'offers'
      },
      "icon": "cart"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.offers')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'kompa'
      },
      "icon": "file"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.kompa')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'active-revisions'
      },
      "icon": "future"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.activeRevisions')))]), _vm._v(" "), _c('li', {
    staticClass: "uk-nav-divider uk-margin-top uk-margin-bottom"
  }), _vm._v(" "), _c('li', {
    staticClass: "uk-nav-header navigation__header"
  }, [_vm._v(_vm._s(_vm.$t('headers.files')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'attachments'
      },
      "icon": "cloud-upload"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.attachments')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'legal-texts'
      },
      "icon": "copy"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.legalTexts')))]), _vm._v(" "), _c('li', {
    staticClass: "uk-nav-divider uk-margin-top uk-margin-bottom"
  }), _vm._v(" "), _c('li', {
    staticClass: "uk-nav-header navigation__header"
  }, [_vm._v(_vm._s(_vm.$t('headers.settings')))]), _vm._v(" "), _c('nav-item', {
    attrs: {
      "to": {
        name: 'tenants'
      },
      "icon": "server"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.tenants')))]), _vm._v(" "), (_vm.isAuthenticatedAsAdmin) ? _c('nav-item', {
    attrs: {
      "to": {
        name: 'organizations'
      },
      "icon": "world"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.organizations')))]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticatedAsAdmin) ? _c('nav-item', {
    attrs: {
      "to": {
        name: 'import-reports'
      },
      "icon": "cloud-download"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.imports')))]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticatedAsAdmin) ? _c('nav-item', {
    attrs: {
      "to": {
        name: 'maintenance'
      },
      "icon": "code"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.maintenance')))]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticatedAsAdmin) ? _c('nav-item', {
    attrs: {
      "to": {
        name: 'queued-jobs'
      },
      "icon": "clock"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.queuedJobs')))]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticatedAsAdmin) ? _c('nav-item', {
    attrs: {
      "to": {
        name: 'users'
      },
      "icon": "users"
    }
  }, [_vm._v(_vm._s(_vm.$t('items.users')))]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "uk-nav-divider uk-margin-top uk-margin-bottom"
  }), _vm._v(" "), _c('li', {
    staticClass: "uk-nav-header navigation__header"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('li', [_c('logout-button')], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ef0cb4f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Navigation.vue
// module id = 1890
// module chunks = 0